import Cookies from 'js-cookie';

const appHeight = () => {
	const doc = document.documentElement
	doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

export function setupModal()
{
	const modal = document.querySelector('.modal-acknowledgement');
	const body = document.body;

	/*
	 * Doesn't Exist
	 */
	if (
		!modal
		|| modal.length <= 0
		|| Cookies.get('site-visited')
	) {
		return
	}

	body.classList.add('modal-active');

	const closeModal = modal.querySelector('#close-modal');

	closeModal.addEventListener('click', () => {
		Cookies.set('site-visited', true, { expires: 1 });
		body.classList.remove('modal-active');
	})

	window.addEventListener('resize', appHeight)

	appHeight()
}



// WEBPACK FOOTER //
// ./scripts/modules/modal.js